import React from "react"
import styled from "styled-components"

import { FormSubscribe } from "Components/"

import { CenterSection } from "Styles"
import { theme } from "Theme"

const Wrapper = styled.section`
  border-radius: ${theme.borderRadius.ui};
  z-index: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 2rem 1rem;

  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    padding: 4rem 2rem;
    flex-direction: column;
  }
  @media (min-width: ${theme.breakpoints.l}) {
    margin: 0 auto;
  }
  max-width: ${theme.layout.base};
`

const Content = styled.div`
  display: block;
  margin: 0 auto;
  text-align: left;
  width: 100%;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const SectionSubscribe = ({ title, subtitle, postSubscribe, children }) => {
  return (
    <>
      <Wrapper>
        <Content>
          {title && title !== "null" && (
            <CenterSection.Title className={!subtitle ? "mb-0" : ""}>{title}</CenterSection.Title>
          )}
          {subtitle && subtitle !== "null" && (
            <CenterSection.Subtitle className={!children ? "mb-0" : ""}>{subtitle}</CenterSection.Subtitle>
          )}
          <FormSubscribe postSubscribe={postSubscribe} />
        </Content>
      </Wrapper>
    </>
  )
}

export default SectionSubscribe
